export default __webpack_public_path__ + "static/media/intro-btn.c0205751.png";